import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/asset/img/personal-icon/uploadAvatar.png'
import _imports_1 from '@/asset/img/personal-icon/edit.png'
import _imports_2 from '@/asset/img/personal-icon/uploadIcon.png'
import _imports_3 from '../../../asset/img/overdue.png'


const _withScopeId = n => (_pushScopeId("data-v-4e703bee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userAccount" }
const _hoisted_2 = { class: "personal-title" }
const _hoisted_3 = { class: "changFlex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "uploadImg",
  src: _imports_1
}, null, -1))
const _hoisted_7 = { class: "edit" }
const _hoisted_8 = { class: "changFlex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "uploadImg",
  src: _imports_1
}, null, -1))
const _hoisted_10 = { class: "edit" }
const _hoisted_11 = { class: "normal" }
const _hoisted_12 = { class: "normal" }
const _hoisted_13 = { class: "changFlex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "uploadImg",
  src: _imports_1
}, null, -1))
const _hoisted_15 = { class: "edit" }
const _hoisted_16 = { class: "normal" }
const _hoisted_17 = { class: "normal" }
const _hoisted_18 = { class: "normal" }
const _hoisted_19 = { style: {"padding-left":"2.125rem"} }
const _hoisted_20 = { class: "uploadJump" }
const _hoisted_21 = { style: {"margin-top":"-2rem"} }
const _hoisted_22 = { class: "certificateList" }
const _hoisted_23 = { style: {"padding-left":"2.125rem"} }
const _hoisted_24 = { class: "certificateList" }
const _hoisted_25 = { style: {"padding-left":"2.125rem"} }
const _hoisted_26 = {
  key: 0,
  class: "iconfont icon-gantanhao2",
  style: {"margin-left":"3rem","color":"red"}
}
const _hoisted_27 = {
  key: 1,
  class: "iconfont icon-gantanhao2",
  style: {"margin-left":"3rem","color":"#fce83b"}
}
const _hoisted_28 = {
  class: "certificateList",
  style: {"margin-left":"9.9375rem"}
}
const _hoisted_29 = {
  key: 0,
  class: "overdue",
  src: _imports_3
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "100%" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('640')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('883')) + ":", 1),
            _createElementVNode("img", {
              style: {"margin-left":"2.6875rem"},
              src: _ctx.isEditavatar ? _ctx.upadteAvatar : _ctx.formData.avatar
            }, null, 8, _hoisted_4),
            _withDirectives(_createVNode(_component_el_upload, {
              accept: ".jpg,.png,.svg",
              "list-type": "picture",
              "file-list": _ctx.photoUrl,
              "before-upload": _ctx.beforeAvatarUpload,
              "auto-upload": false,
              "on-change": _ctx.showUpdateavatar,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["file-list", "before-upload", "on-change"]), [
              [_vShow, _ctx.isEditavatar]
            ])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_el_button, { onClick: _ctx.closeAvatar }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('217')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeEdit('avatar')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('284')), 1)
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.isEditavatar]
          ]),
          _withDirectives(_createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditavatar = true)),
            class: "hover_opacity"
          }, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('674')), 1)
          ], 512), [
            [_vShow, !_ctx.isEditavatar]
          ])
        ]),
        _createVNode(_component_el_form, {
          rules: _ctx.formRues,
          model: _ctx.form
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('884')) + ":", 1),
                (_ctx.isEdituser)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "updateUsername",
                      style: {"margin-top":"1.2rem"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: _ctx.t('885'),
                          modelValue: _ctx.form.updateUsername,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.updateUsername) = $event)),
                          maxlength: "10"
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("span", { class: "spanEdit" }, _toDisplayString(_ctx.formData.username), 513), [
                  [_vShow, !_ctx.isEdituser]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEdituser = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('217')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeEdit('user')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('284')), 1)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isEdituser]
              ]),
              _withDirectives(_createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isEdituser = true)),
                class: "hover_opacity"
              }, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('674')), 1)
              ], 512), [
                [_vShow, !_ctx.isEdituser]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('662')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.formData.jobNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('630')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.formData.account), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('665')) + ":", 1),
                (_ctx.isEditphone)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "updatePhone",
                      style: {"margin-top":"1.2rem"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: _ctx.t('886'),
                          modelValue: _ctx.form.updatePhone,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.updatePhone) = $event)),
                          maxlength: "11"
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("span", { class: "spanEdit" }, _toDisplayString(_ctx.formData.phone), 513), [
                  [_vShow, !_ctx.isEditphone]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isEditphone = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('217')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeEdit('phone')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('284')), 1)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isEditphone]
              ]),
              _withDirectives(_createElementVNode("div", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isEditphone = true)),
                class: "hover_opacity"
              }, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('674')), 1)
              ], 512), [
                [_vShow, !_ctx.isEditphone]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('887')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.formData.region), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('650')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.formData.roleName), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('888')) + ":", 1),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formData.teamName), 1)
            ])
          ]),
          _: 1
        }, 8, ["rules", "model"]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: _imports_2,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.activePath && _ctx.activePath(...args)))
          }),
          _createElementVNode("span", {
            style: {"padding":"0"},
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.activePath && _ctx.activePath(...args)))
          }, _toDisplayString(_ctx.t('889')), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificateList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('862')) + ":", 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(item.certificateName), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('864')) + ":", 1),
                _createElementVNode("span", _hoisted_25, _toDisplayString(item.deadtime), 1),
                (_ctx.timer[index] < 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, " " + _toDisplayString(_ctx.t('868')), 1))
                  : _createCommentVNode("", true),
                (_ctx.timer[index] < 30 && _ctx.timer[index] >= 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, " " + _toDisplayString(_ctx.t('869')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (url) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: url,
                    style: {"position":"relative"}
                  }, [
                    _createVNode(_component_el_image, {
                      src: url,
                      lazy: ""
                    }, null, 8, ["src"]),
                    (_ctx.timer[index] < 0)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}